/* ========================================================================
   SWF Bundler — shared JS
   Loaded once per page via {{ 'swf-bundler.js' | asset_url | script_tag }}

   Handles:
   - FAQ accordion (single-open)
   - Sticky mobile CTA show/hide + dismiss
   ======================================================================== */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); return; }
    document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    /* ——— FAQ accordion ——— */
    document.querySelectorAll('.swf-bundler-page .swf-faq-q').forEach(function (q) {
      q.addEventListener('click', function () {
        var item = q.closest('.swf-faq-item');
        if (!item) return;
        var wasOpen = item.classList.contains('open');
        // Only collapse siblings within the same FAQ section
        var section = q.closest('.swf-faq');
        if (section) {
          section.querySelectorAll('.swf-faq-item').forEach(function (i) { i.classList.remove('open'); });
        }
        if (!wasOpen) item.classList.add('open');
      });
    });

    /* ——— Sticky mobile CTA ——— */
    var wrap = document.getElementById('swfStickyCta');
    if (!wrap) return;

    var closeBtn = wrap.querySelector('.swf-sticky-cta-close');
    var hero = document.querySelector('.swf-hero-section');
    var finalSection = document.querySelector('.swf-final-section');

    // Dismiss persists for this session only
    try {
      if (sessionStorage.getItem('swfStickyCtaDismissed') === '1') {
        wrap.classList.add('dismissed');
        return;
      }
    } catch (e) {}

    function updateVisibility() {
      if (!hero) { wrap.classList.add('visible'); wrap.setAttribute('aria-hidden', 'false'); return; }
      var heroBottom = hero.getBoundingClientRect().bottom;
      var pastHero = heroBottom < 40;
      if (pastHero) {
        wrap.classList.add('visible');
        wrap.setAttribute('aria-hidden', 'false');
      } else {
        wrap.classList.remove('visible');
        wrap.setAttribute('aria-hidden', 'true');
      }
    }

    if (finalSection && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            wrap.classList.add('hidden-at-end');
          } else {
            wrap.classList.remove('hidden-at-end');
          }
        });
      }, { rootMargin: '0px 0px -40% 0px' });
      io.observe(finalSection);
    }

    window.addEventListener('scroll', updateVisibility, { passive: true });
    updateVisibility();

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        wrap.classList.add('dismissed');
        try { sessionStorage.setItem('swfStickyCtaDismissed', '1'); } catch (e) {}
      });
    }
  });
})();
